import { Skeleton } from "@/components/ui/feedback/skeleton";
import { cn } from "@/src/lib/utils";

interface BadgeSkeletonProps extends React.HTMLAttributes<HTMLDivElement> {}

export function BadgeSkeleton({ className }: BadgeSkeletonProps) {
  return <Skeleton className={cn("w-28 h-6 rounded-full", className)} />;
}
